import React from "react";
import { Typography, Container, Divider } from "@material-ui/core";

function Publications() {
	return (
		<Container maxWidth="md">
		<br />
			<Typography variant="h4" align="center">
				Research Group Publications
			</Typography>
      <br />< br/><br />
			<Typography variant="h6" style={{ fontWeight: "bold" }}>
			The following is a list of every publication from the City@UMD team. Every source contains
			a link to a PDF of the publication which can be accessed by clicking on the first listed name.
			</Typography>
			<br /><br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1lSkGPgrVWAg5Ek_b4rv6qqimSkREMi-3/view?usp=sharing">Zhu</a>, S., Jenkins, S., Addo, K., Heidarinejad, M., Romo, S., Layne, A., Ehizibolo,
			J., Dalgo, D., Mattise, N., Milton, D., and Srebric, J., 2020. “Ventilation and
			Laboratory Confirmed Acute  Respiratory  Infection  (ARI)  Rates  in  College
			Residence  Halls  in  College  Park, Maryland,” <strong>Environment International</strong>, 137
			(2020), p.105537.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://doi.org/10.1016/j.scs.2020.102385">Kim</a>, M.K., Kim, Y.S., and Srebric, J. 2020. “Predictions of Electricity
			Consumption in a Campus Building Using Occupant Rates and Weather Elements
			with Sensitivity Analysis: Artificial Neural Network vs. Linear Regression,”
			Sustainable Cities and Society,.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://doi.org/10.1016/j.scs.2020.102321">Kim</a>, M.K., Kim, Y.S., and Srebric, J. 2020. “Impact of Correlation of Plug
			Load Data, Occupancy Rates and Local Weather Conditions on Electricity Consumption
			in a Building Using Four Back-propagation Neural Network Models,” Sustainable
			Cities and Society,.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1GYq0mFr_1bed8Dr_iXC9qonV718bs4vz/view?usp=sharing">Alhafi</a>, Z., and Srebric, J. 2020. “Tradeoffs between Energy Use and
			Ventilation Rates in U.S. Retail Stores,” <strong>Science and Technology for the
			Built Environment</strong>, 26 (5), 713-725.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/15LmBeCQt58GgR5tMiHRfxs21ek1SV3tM/view?usp=sharing">Liu</a>, J., Li, Z., Kim, M.K., Zhu, S., Zhang, L., and Srebric, J. 2020.
			“A Comparison of the Thermal Comfort Performances of a Radiation Floor
			Cooling System when Combined with a Range of Ventilation Systems,” <strong>Indoor
			 and Built Environment</strong>, Volume: 29 issue: 4, page(s): 527-542.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/11aoBNjpYQfoU6KirB6WPOYi_Qe6rxDUu/view?usp=sharing">Zhang</a>, L., Liu, J., Heidarinejad, M., Kim, M.K., and Srebric, J., 2020.
			“A Two-Dimensional Numerical Analysis for Thermal Performance of an Intermittently
			Operated Radiant Floor Heating System in a Transient External Climatic Conditions,”
			<strong>Heat Transfer Engineering</strong>, DOI: 10.1080/01457632.2019.1576422
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1eoAQuMTR4d9E7KOXBqJuqA9fIUDEGVvc/view?usp=sharing">Mi</a>, R., Li, T., Dalgo, D., Chen, C., Kuang, Y., He, S., Zhao, X.,
			Heidarinejad, M., Xie, W., Gan, W., Zhu, J., Srebric, J., Yang, R., and Hu,
			L. 2020. “A Clear, Strong, and Thermally-Insulated Transparent Wood for
			Energy Efficient Windows,” <strong>Advanced Functional Materials</strong>, 30(1), p.1907511.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1KdZCJ1lwKJWRuzVPT_qzSP27aqgByzDv/view?usp=sharing">Liu</a>, J., Dalgo, D.A., Zhu, S., Li, H., Zhang, L. and Srebric, J., 2019
			“Performance analysis of a ductless personalized ventilation combined with
			 radiant floor cooling system and displacement ventilation,”  <strong>Building Simulation</strong>,
			  Vol. 12, No. 5, pp. 905-919.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1_PbC7x1Bwzg57Pbz_dTOqXDFouqA2Ir2/view?usp=sharing">Li</a>, T., Zhai, Y., Heidarinejad, M., Gan, W., Jia, C., Dalgo, D., Zhao, X.,
			Yang, R., Srebric, J., Yin, X., and Hu, L., 2019. “A Radiative Cooling
			Structural Material,” <strong>Science</strong>, 364 (6442), 760-763.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1q2HvDcfnUDjo9ssejl_SyUnRQoSXa2lA/view?usp=sharing">Liu</a>, J., Heidarinejad, M., Nikkho, S.K., Mattise, N.W. and Srebric, J., 2019.
			“Quantifying Impacts of Urban Microclimate on a Building Energy Consumption—A
			 Case Study.” <strong>Sustainability</strong>, 11(18), 4921.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/19ZKjNH5bTytDDh-NKeTU9X6jYm0m5w6R/view?usp=sharing">Liu</a>, J., Zhu, S., Kim, M.K., Srebric, J. 2019. “A Review of CFD Analysis Methods for
			Personalized Ventilation (PV) in Indoor Built Environments,” <strong>Sustainability</strong>, 2019, 11(15), 4166.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1rwLwOYtPs-8KtQrH2CnahhBsNAJ8iHoW/view?usp=sharing">Li</a>, J., Liu, J., Srebric, J., Hu, Y., Liu, M., Su, L., and Wang, S. 2019.
			“The Effect of Tree-Planting Patterns on the Microclimate within a Courtyard,”
			<strong> Sustainability</strong>, 2019, 11(6), 1665.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/13nsCMtwzPieAQd8ipI4mAwyJbhVPZ5HX/view?usp=sharing">Liu</a>, J., Heidarinejad, M., Pitchurov, G., Zhang, L., and Srebric, J. 2018 “An Extensive
			Comparison of Modified Zero-Equation, Standard k-ε, and LES Models in
			Predicting Urban Airflow,” <strong>Sustainable Cities and Society</strong>, 40(2018): 28-43.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1bozFMjbHOkYWLZpjtufdvnhogrglEf4F/view?usp=sharing">Heidarinejad</a>, M., Dalgo, D., Mattise, N., and Srebric, J. 2018. “Personalized
			Cooling as an Energy Efficiency Technology for City Energy Footprint Reduction,”
			Special Issue on Cities and Climate Change, <strong>Journal of Cleaner Production</strong>, 171(2018): 491-505.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1w80xYnk2cgqeE1ro6YMVRuYmdX1q5rRT/view?usp=sharing">Heidarinejad</a>, M., Dahlhausen, M., Mattise, N., Sharma, K., Benne, K., Macumber, D.,
			Brackney, L., and Srebric, J. 2017. “Demonstration of Reduced-Order Urban Scale
			Building Energy Models,” <strong>Energy and Buildings</strong>, 156(2017): 17-28.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1CGZ_vNcivf_ma0a3S7CFxbPmE-v0YjVg/view?usp=sharing">Zhu</a>, S., Dalgo, D., Srebric, J., and Kato, S. 2017. “Cooling Efficiency of
			 a Spot-type Personalized Ventilation,” <strong>Building and Environment</strong>, 121(2017): 35-48.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1VqNo70YEINLpbavcvNIAA7ivNQj5eWEk/view?usp=sharing">Heidarinejad</a>, M., Cedeño-Laurent, J.G., Wentz, J.R., Rekstad, N.M., Spengler,
			J.D., and Srebric, J. 2017. “Actual Building Energy Use Patterns and Their
			Implications for Predictive Modeling,” <strong>Energy Conversion and Management</strong>, 144(2017): 164–180.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1imly_GZtMgHhuwopo1V-N6Y0K6Di_99j/view?usp=sharing">Kim</a>, Y.S., Heidarinejad, M., Dahlhausen, M., Srebric, J. 2017. “Building
			Energy Model Calibration with Occupancy and Plug-Load Schedules Derived
			from Electricity Use Data,” <strong>Applied Energy</strong>, 190(2017): 997-1007.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1h8tt_kGO2OVEA-ivRgv56wvIx-k_WXA3/view?usp=sharing">Khoshdel Nikkho</a>, S., Heidarinejad, M., Dalgo, D., and Srebric, J. 2017.
			“Quantifying the Impact of Urban Wind Sheltering on the Building Energy
			 Consumption,” <strong>Applied Thermal Engineering</strong>, 116(2017): 850-865.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1NCOmaOsMqOKBMc-ifsZxj4ZuTrFyVhss/view?usp=sharing">Kim</a>, Y.S., and Srebric, J. 2017. “Impact of Occupancy Rates on the Building
			Electricity Consumption in Commercial Buildings,” <strong>Energy and Buildings</strong>,
			138(2017): 591-600.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1SXU23yMrYKbNFL1-hkaupzZIAi67JZZh/view?usp=sharing">Kim</a>, M.K., Barber C., and Srebric J. 2017. “Traffic Noise Level Predictions for
			Buildings with Windows Opened for Natural Ventilation in Urban Environments,”
			<strong> Science and Technology for the Built Environment</strong>, 23(2017): 726-735.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1c-cX4KlU0QqZVbmwOTfK4ssBo3y-2i2J/view?usp=sharing">Delgoshaei</a>, P., Heidarinejad, M., Xu K., Wentz, J.R., Delgoshaei, P., and
			Srebric, J. 2017. “Impacts of Building Operational
			 Schedules and Occupants on the Lighting Energy Consumption Patterns of an
			  Office Space,” <strong>Building Simulation Journal</strong>, 10(2017): 447-458.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1NPx4SrI00fCFrFQC6JU4WRx_T9NWDOIt/view?usp=sharing">Motesharrei</a>, S., Rivas, J., Kalnay, E., Asrar, G., Busalacchi, A., Cahalan, R.,
			Cane, M.A., Colwell, R., Feng, K., Franklin, R., Hubacek, K., Miralles-Wilhelm,
			 F., Miyoshi, T., Ruth, M., Sagdeev, R., Shirmohammadi, A., Shukla, J., Srebric,
			 J., Yakovenko, V., and Zeng, N. 2016. “Population, Inequality, and Resource-Use:
		 Modeling Sustainability Requires Bidirectional Coupling of the Earth and
		 Human Systems,” <strong>National Science Review</strong>, 3(2016): 470–494.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1oSN1Gnd3y1OIUDIhjiig0trPThQgbLdY/view?usp=sharing">Heidarinejad</a>, M., Gracik, S., Sadeghipour Roudsari, M., Khoshdel Nikkho, S.,
			Liu, J., Liu, K., Pitchorov, G., and Srebric, J. 2016. “Influence of Building
			Surface Solar Irradiance on Environmental Temperatures in Urban Neighborhoods,”
			<strong> Sustainable Cities and Society</strong>, 26(2016): 186-202.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1QfmX_9dvoPV41NY7jwDxOYE_Ouv6wKlt/view?usp=sharing">Chen</a>, X., Wang, Q., and Srebric, J. 2016. “Occupant Feedback Based Model
			 Predictive Control for Thermal Comfort and Energy Optimization: A Chamber
			  Experimental Evaluation,” <strong>Applied Energy</strong>, 164(2016): 341–351.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1tVosuNdOMfR3xGTs4WmsbVnv6ceEpyoM/view?usp=sharing">Gangisetti</a>, K., Claridge, D., Srebric, J., and Paulus, M. 2016. “Influence
			of Reduced VAV Flow Settings on Indoor Thermal Comfort in an Office Space,”
			<strong> Building Simulation Journal</strong>, 9(2016): 101-111.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1vCssKJdnuwrJFPLCppPquPs6NP7VDMwA/view?usp=sharing">DeLoid</a>, G.M., Cohen, J.M., Pyrgiotakis, G., Pirela, S.V., Pal, A., Liu, J., Srebric, J.,
			and Demokritou, P. 2015. “Advanced Computational Modeling for In Vitro
			Nanomaterial Dosimetry,” <strong>Particle and Fibre Toxicology</strong>, 12:32, 2015.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1F_FmHLaKlUODEsBoE86ldRw4q2cJQhcL/view?usp=sharing">Han</a>, G., and Srebric, J. 2015. “Comparison of Survey and Numerical Sensitivity
			Analysis Results to Assess the Role of Life Cycle Analyses from Building
			Designers’ Perspectives,” <strong>Energy and Buildings</strong>, 108(2015): 463-469.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1E2d3vCg3OB7r96NQloognj7SGUGG71C_/view?usp=sharing">Dahlhausen</a>, M., Heidarinejad, M., and Srebric, J., 2015. “Building Energy
			Retrofits under Capital Constraints and Greenhouse Gas Pricing Scenarios,”
		  <strong> Energy and Buildings</strong>, 107(2015): 407-416.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/16pUnSaSYxcxvaJywEXRwg3YQVkosjI0l/view?usp=sharing">Zhao</a>, M., Kim, Y.S., and Srebric, J. 2015. “Occupant Perceptions and a
			Health Outcome in Retail Stores,” <strong>Building and Environment</strong>, 93/2(2015): 385-394.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/16DH2dhJuIgXCW89HZA0O9oakOjALcFOO/view?usp=sharing">Yaghoobian</a>, N., Srebric, J. 2015. “Influence of Plant Coverage on the
			Total Green Roof Energy Balance and Building Energy Consumption,”
			<strong> Energy and Buildings</strong>, 103(2015): 1-13.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1W1zwoCjU4YsGBEEGW7quNmJ7o_xi7Z4m/view?usp=sharing">Chen</a>, X., Wang, Q., and Srebric, J. 2015. “Model Predictive Control for
			Indoor Thermal Comfort and Energy Optimization Using Occupant Feedback,”
			<strong> Energy and Buildings</strong>, 102(2015): 357-369.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1BpKGYdLdqQNKQc80YQWA_ecgexPcYD2u/view?usp=sharing">Jareemit</a>, D., and Srebric, J. 2015. “A Characterization of Time-Dependent
			Air Infiltration Rates in Retail Stores Using Calibrated Multi-zone Model,”
			<strong> Science and Technology for the Built Environment</strong>, 21(4): 420-428.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1jfuskz6WIoeS5bAhRZlQtQL1kv8VyC6B/view?usp=sharing">Srebric</a>, J., Heidarinejad, M., Liu, J. 2015. “Building Neighborhood
			Emerging Properties and their Impacts on Multi-Scale Modeling of Building
			Energy and Airflows,” <strong>Building and Environment</strong>, 91(2015): 246-262.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1sCTopJJZJlJMarKSaCzJ4vsPunk45Sxh/view?usp=sharing">Liu</a>, J., Heidarinejad, M., Gracik, S., Srebric, J., and Yu, N. 2015. “An
			Indirect Validation of Convective Heat Transfer Coefficients (CHTCs)
			for External Building Surfaces in an Actual Urban Environment,”
			<strong> Building Simulation Journal</strong>, 2015(8): 337-352.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1gi1XLTrf2BFQssotSO3GXfAQV5NDgEIc/view?usp=sharing">Zhao</a>, M., Srebric, J., Berghage, R., Dressler K., 2015. “Accumulated Snow
			Layer Influence on the Heat Transfer Process through Green Roof
			Assemblies,” <strong>Building and Environment</strong>, 87(2015): 82-91.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/17cFKoZfpL6XMFGxpjisS_NT7rTwhjrTA/view?usp=sharing">Chen</a>, X., Wang, Q., and Srebric, J. 2015. “A Data-driven State-space
			Model of Indoor Thermal Sensation Using Occupant Feedback for
			Low-Energy Buildings,” <strong>Energy and Buildings</strong>, 91(2015): 187-198.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1f-Y-wTxpS5aaZDyM7g5tNIEr1Mw2suLH/view?usp=sharing">Pitchurov</a>, G., Srebric, J., Zhu, S., Vincent R.L., Rudnick, S.N., and
			Brickner P.W. 2015. “A Validated Numerical Investigation of the Ceiling
			Fan's Role in the Upper-Room UVGI Efficacy,”
			<strong> Building and Environment</strong>, 86(2015): 109-119.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1HhxWdywZxqcXr4FaeMFBjLl8DsJLD_P9/view?usp=sharing">Liu</a>, J., Heidarinejad, M., Gracik, S., and Srebric, J. 2015.
			“The Impact of Exterior Surface Convective Heat Transfer
			Coefficients on the Building Energy Consumption in Urban Neighborhoods
			with Different Plan Area Densities,” <strong>Energy and Buildings
			</strong>, 86(2015): 449-463.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/13NqaDHiG_qUlJEghyHive-3UpAiJ1zti/view?usp=sharing">Han</a>, G., Srebric, J., and Enache-Pommer, E. 2015. “Different Modeling
			Strategies of Infiltration Rates for an Office Building to
			Improve Accuracy of Building Energy Simulations,” <strong>Energy and Buildings</strong>, 86(2015): 288-295.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1Xr9eNSV0nYmkyR7t-WdD3B0_QYxr6_Qi/view?usp=sharing">Gracik</a>, S., Heidarinejad, M., Liu, J., Srebric, J. 2015. “Effect of
			Urban Neighborhoods on the Performance of Building Cooling Systems,”
			<strong> Building and Environment</strong>, 90(2015): 15-29.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1qGVvRDsnd02SpaqwAHAZcYdpsTzLPpjb/view?usp=sharing">Kim</a>, Y.S., and Srebric, J. 2015. “Improvement of Building Energy
			Simulation Accuracy with Occupancy Schedules derived from Hourly
			Building Electricity Consumption,” <strong>ASHRAE Transactions</strong>,
			121(1): 353-360.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1OAxcQF862ZdheQ1lCYxeRbOB1gB2J_-M/view?usp=sharing">Liu</a>, J., Heidarinejad, M., Guo, M., and Srebric, J. 2015. “Numerical
			Evaluation of the Local Weather Data Impacts on Cooling Energy Use of
			Buildings in an Urban Area,” <strong>Procedia Engineering</strong>, 121(2015): 381 – 388.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1KdyYQB4KhgFnzWKRbqJlz4aOIhEjBFsF/view?usp=sharing">Heidarinejad</a>, M., Dahlhausen, M., and Srebric, J. 2014. “Cluster Analysis
			of Simulated Energy Use for LEED Certified U.S. Office Buildings,”
			<strong> Energy and Buildings</strong>, 85(2014): 86–97.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1miYdB1l6iMn5uJu7s4mHBVZN5M1_7neT/view?usp=sharing">Han</a>, G., Srebric, J., and Enache-Pommer, E. 2014. “Variability of Optimal
			Solutions for Building Components Based on Comprehensive Life Cycle Cost
			Analysis,” <strong>Energy and Buildings</strong>, 79(2014): 223-231.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/16HdsEVBGfEXCutlijmOhKo_csNG5hRmh/view?usp=sharing">Jareemit</a>, D., Shu, S., and Srebric, S. 2014. “A field investigation of air
			infiltration rates through automatic entrance doors in retail buildings,”
			<strong> BUILT</strong>, International Journal of Building, Urban, Interior, and Landscape
			Technology, 2014(4): 51–59.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1hW2GpHp8jH-tmLElXZGKm4DxPY4rnXtZ/view?usp=sharing">Davidovic</a>, D., Liu, J., Heidarinejad, M., and Srebric, J. 2014.
			“Airflow Study for a Cluster of Campus Buildings using
			Different Turbulence Modeling Approaches,” <strong>BUILT</strong>, International
			Journal of Building, Urban, Interior and Landscape Technology, 2014(3): 33-56.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1M_XcxVUM4ZCgJEq_5cCmZ7k9i8-ebUy4/view?usp=sharing">Zhao</a>, M., Tabares-Velasco, P.C., Srebric, J., Komareni, S., and Berghage, R. 2014.
			“Effects of plant and substrate selection on thermal performance of green roofs
			during the summer,” <strong>Energy and Buildings</strong>, 78(2014): 199-211.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1SchWigr733Lt6rizaIQq9i-LWANHMOGG/view?usp=sharing">Zaataria</a>, M., Nirloa, E., Jareemit, D., Craina, N., Srebric, J., and
			Siegel, J. 2014. “Ventilation and Indoor Air Quality in Retail Stores:
			A Critical Review (RP-1596),” <strong>Science and Technology for the Built
			Environment</strong>, 20(2014): 276-294.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1RI6fiWmWNsXV-6vlv5sJLCCaO6jgFMmN/view?usp=sharing">Zhu</a>, S., Srebric, J., Rudnick, S.N., Vincent, R.L., and Nardell, E.A. 2014. “Numerical modeling of
			 indoor environment with a ceiling fan and an upper-room ultraviolet
			 germicidal irradiation system,” <strong>Building and Environment</strong>, 72(2014): 116-124.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1vGtlneIjHszOmyQNC_ei_1j1tnwB9uJL/view?usp=sharing">Liu</a>, J., Srebric, J., and Yu, N. 2013. “Numerical simulation of convective
			 heat transfer coefficients at the external surfaces of building arrays
			 immersed in a turbulent boundary layer,” <strong>Int. Journal of Heat and Mass
			  Transfer</strong>, 61(2013): 209-225.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/12HJJYfKGqTuO2Bb6Kat_fUtYJf2kYM0b/view?usp=sharing">Zhu</a>, S., Srebric, J., Rudnick, S.N., Vincent, R.L., and Nardell, E.A. 2013. “Numerical Investigation of
			Upper-Room UVGI Disinfection Efficacy in an Environmental Chamber with a Ceiling Fan,”
			<strong> Photochemistry and Photobiology</strong>, 89(4): 782-791.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1ghniJMjP2xW2oDLZED1VP8m5t0ZRHytl/view?usp=sharing">Heidarinejad</a>, M., and Srebric, J. 2013. “Computational Fluid Dynamics
			Modeling of UR-UVGI Lamp Effectiveness to Promote Disinfection of Airborne
			Microorganisms,” invited paper for a special issue on “Technological
			Advancements That Improve or Enhance Energy Efficiency in Healthcare
			Facilities” <strong>World Review of Science, Technology and Sustainable Development</strong>
			(WRSTSD), 10(2013): 78-95.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1rbMxMzlQQ5RdJbSJVOyYhUubIAB1aU7k/view?usp=sharing">Zhao</a>, M., and Srebric, J. 2012. “Assessment of green roof performance for
			sustainable buildings under winter weather conditions,” <strong>Journal
			of Central South University</strong>, 19(2012): 639-644.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1meX3TsLHU_LxDwhy5soc_nQe4l7Si97r/view?usp=sharing">Tabares-Velasco</a>, P.C., Zhao, M., Peterson, N., Berghage, R., and Srebric, J. 2012.
			“Validation of Predictive Heat and Mass Transfer Green Roof Model with
			Extensive Green Roof Field Data,” <strong>Ecological Engineering</strong>,
			47(2012): 165-173.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/11Cidp6AKAfZdbAog6Hnddx3iHbFI11dU/view?usp=sharing">Tabares-Velasco</a>, P.C., and Srebric, J. 2012. “A heat transfer model for
			assessment of plant based roofing systems in summer conditions,”
			<strong> Building and Environment</strong>, 49(2012): 310-323.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1ROewvSXqFge4gtkt3FqRtPhv0kDVFZvP/view?usp=sharing">Davidovic</a>, D., Pinon, J., Burnett, E.F., and Srebric, J. 2012.
			“Analytical Procedures For Estimating Air Flow Rates In Ventilated,
			creened Wall Systems (VSWS),” <strong>Building and Environment</strong>, 47(2012): 126-137.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/15GtiVkXfZsSmVpXeRJvm2Zg8lKMPX8fc/view?usp=sharing">Zhu</a>, S., Srebric, J., Spengler, J.D., and Demokritou, P. 2012. “An advanced
			numerical model for the assessment of airborne transmission of influenza in
			bus microenvironments,” <strong>Building and Environment</strong>, 47(2012): 67-75.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1BBRsLXyWO-PUejL650UM-D69YWblkR2y/view?usp=sharing">Tabares-Velasco</a>, P.C., and Srebric, J. 2011. “Experimental Quantification
			of Heat and Mass Transfer Process through a Vegetated Roof Assembly in a
			new Laboratory Setup,” <strong>Int. Journal of Heat and Mass Transfer</strong>,
			54 (2011): 5149-5162.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1DyfedE9nQzP-FEOrMc1IIK2rIyOlV4du/view?usp=sharing">Ayata</a>, T., Tabares-Velasco, P.C., and Srebric, J. 2011. “An Investigation
			of Sensible Heat Fluxes at a Green Roof in a Laboratory Setup,”
			<strong> Building and Environment</strong>, 46(9): 1851-1861.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1-0Ycj_kITJOtSzaJxFyHzRifwDT6fE4o/view?usp=sharing">Khalajzadeh</a>, V., Heidarinejad, G., and Srebric, J. 2011. “Parameters
			Optimization of a Vertical Ground Heat Exchanger Based on Response Surface
			Methodology,” <strong>Energy and Buildings</strong>, 43(6): 1288-1294.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1oOTa4rXsub4tJ2aMkVW9G9XzWPhjeNxN/view?usp=sharing">Qian</a>, Y., and Srebric J. 2010. “Development and Validation of an Algebraic
			 Turbulence Model for Outdoor Airflow and Contaminant Simulations around a
			 Building,” invited paper for the inaugural issue of <strong>International
			 Journal in Building, Urban, Interior and Landscape Technology (BUILT)</strong>.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/17cXUyGhyb4KAKHCusllM0nX1P5ooMcDV/view?usp=sharing">Vukovic</a>, V., Tabares-Velasco, P.C., and Srebric, J. 2010. “Real-Time
			Identification of Indoor Pollutant Source Positions Based on Neural Network
			Locator of Contaminant Sources (LOCS) and Optimized Sensor Networks,”
			<strong> Journal of the Air & Waste Management Association</strong>, 60: 1034-1048.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1Y6KXY82-QhYk0cuWDkpLWEEET0dbKKy-/view?usp=sharing">Tabares-Velasco</a>, P.C. and Srebric, J. 2009. “The Role of Plants in the
			Reduction of Heat Flux through Green Roofs: Laboratory Experiments,” <strong>ASHRAE Transactions
			</strong>, 115(2): 793-802.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1Pls_mo9GKWEuTa7FOZjaqf3AQYuYNTeu/view?usp=sharing">Yang</a>, C., Yang, X., Xu, Y., and Srebric, J. 2009. “Contaminant dispersion
			 with personal displacement ventilation Part I: baseline case study,”
			 <strong> Building and Environment</strong>, 44(10): 2121-2128.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1tLBFZAz3mAhyxbHB1GF4qe0pKGfGNEqI/view?usp=sharing">Srebric</a>, J., Yuan, J., and Novoselac, A. 2008. “On-Site Experimental
			Validation of a Coupled Multi-zone and CFD Model for Building Contaminant
			Transport Simulations,” <strong>ASHRAE Transactions</strong>, 114(1): 273-281.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1M2t7ysKQBfdqVsN4eKiOjRg7cDzqZjBj/view?usp=sharing">Srebric</a>, J., Vukovic, V., He, G., and Yang, X. 2008. “CFD Boundary
			Conditions for Contaminant Dispersion,
			Heat Transfer, and Airflow Simulations around Human Occupants in
			Indoor Environments,” <strong>Building and Environment</strong>, 43(3): 294-303.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1cZn3MrUD0yJhjs4Urnzr1eiSm6pdW-b9/view?usp=sharing">Mansour</a>, A., Srebric, J., and Burley, B.J. 2007. “Development of Straw-cement
			Composite Sustainable Building Material for Low-cost Housing in Egypt,”
			<strong> Journal of Applied Sciences Research</strong>, 3(11): 1571-1580.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1pn3h_K0aASLI-A65bNsAJoNyb657DJMe/view?usp=sharing">Choi</a>, J., Kim, Y., Sivasubramaniam, A., Srebric, J., Wang, Q., and Lee, Q.
			2007. “A CDF-based Tool for Studying Temperature in Rack-mounted Servers”
			<strong> IEEE Transactions on Computers</strong>, 57(8): 1129-1142.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1xC3L1QB1dUHzTkRIYTX86xFR8pM3il25/view?usp=sharing">Vukovic</a>, V., and Srebric, J. 2007. “Application of Neural Networks Trained
			with Multi-Zone Models for Fast Detection of Contaminant Source Position in
			Buildings,” <strong>ASHRAE Transactions</strong>, 113(2): 154-162.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1dhxCaIlEL-zhyMR4NGc4sioUq3N0M7Ji/view?usp=sharing">Novoselac</a>, A., Burley, B.J., and Srebric, J. 2006. “Development of New and
			Validation of Existing Convection Correlations for Rooms With Displacement
			Ventilation Systems,” <strong>Energy and Buildings</strong>, 38(3): 163-173.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/111XnmGnnR0_fQwkvsvfx1Da0nqXntTHQ/view?usp=sharing">Davidovic</a>, D., Srebric, J, and Burnett E. 2006. “Modeling Convective Drying
			of Ventilated Wall Chambers in Building Enclosures,”
			<strong> International Journal of Thermal Sciences</strong>, 45(2): 180-189.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/10MCvnu_JGk60XZRBldUWP1RoE-9FAnb2/view?usp=sharing">Novoselac</a>, A., Burley, B.J. and Srebric, J. 2006. “New Convection
			Correlations for Cooled Ceiling Panels in Room with Mixed and Stratified
			Airflow,” <strong>Science and Technology for the Built Environment</strong>
			, 12(2): 17 pages.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1w6xZEkiecfqVc6wbw1efpUBE2WQV-j06/view?usp=sharing">He</a>, G., Yang, X., and Srebric, J. 2005. “Removal of Contaminants Released from
			Room Surfaces by Displacement and Mixing Ventilation: Modeling and Validation,”
			<strong> Indoor Air: International Journal of Indoor Air</strong>, 15(5): 367-380.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1DM80SWxKpbbjgPFMnkAHq4r6gnf-Bk8T/view?usp=sharing">He</a>, G., Yang, X. and Srebric, J. 2005. “Effects of Source Type and Location
			on Contaminant Dispersion in a Displacement Ventilated Room,”
			<strong> ASHRAE Transaction</strong>, 111(1): 646-652.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/12R0HWSruGNDc2GGnNSPA1pyAfcJYLiAa/view?usp=sharing">Yang</a>, X., Srebric, J., Li, X. and He, G. 2004. “Performance of Three Air
			Distribution Systems in VOC Removal from an Area Source,”
			<strong> Building and Environment</strong>, 39(11):1289-1299.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1FWFN_jQJoacPWtLGhVdmi1wuIeugWjXv/view?usp=sharing">Zhai</a>, Z., Srebric, J. and Chen, Q. 2003. “Prediction and Control of
			Chemical and Biological Agent Dispersion in Buildings,”
			<strong> Int. J. of Ventilation</strong>, 2(3): 251-264.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1K32hhU0BhffyNvfWnBeio_QlvN9BTUIg/view?usp=sharing">Novoselac</a>, A. and Srebric, J. 2003. “Comparison of Air Exchange Efficiency
			and Contaminant Removal Effectiveness as IAQ Indices,” <strong>ASHRAE Transactions</strong>,
			109(2): 339-349.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1kDBkWY56WWjpA-p_aoetkkgUWcpTx8cg/view?usp=sharing">Novoselac</a>, A. and Srebric, J. 2002. “A Critical Review on the Performance
			and Design of Combined Cooled Ceiling and Displacement Ventilation Systems,”
			<strong> Energy and Buildings</strong>, 34 (5): 497-509.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1rOxqm0hGQN4cjytf1k8ptxz3vgvvKbEN/view?usp=sharing">Srebric</a>, J. and Chen, Q. 2002. “An Example of Verification, Validation,
			and Reporting of Indoor Environment CFD Analyses,” <strong>ASHRAE Transactions</strong>,
			108(2): 185-194.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1Y5oDl0YOtbhIVVxlXjZHGJSCUELpYVcm/view?usp=sharing">Srebric</a>, J. and Chen, Q. 2002. "Simplified Numerical Models for Complex
			Air Supply Diffusers," <strong>Science and Technology for the Built Environment</strong>,
			8(3): 277-294.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1vkIe4tG4jinjpAVheviSwWq4d9ngTE51/view?usp=sharing">Chen</a>, Q. and Srebric, J. 2002. “A Procedure for Verification, Validation,
			and Reporting of Indoor Environment CFD Analyses,” <strong>Science and Technology
			for the Built Environment</strong>, 8(2): 201-216.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1dAhZpRfBXC6m_IW7VZeSHQRSn4bhNGRl/view?usp=sharing">Tantasavasdi</a>, C., Srebric, J., and Chen, Q. 2001. “Natural Ventilation
			Design for Houses in Thailand,” <strong>Energy and Buildings</strong>, 33 (8): 815-824.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1mT2z-WmJYQl0LG0a_7ayCuQBavYD1zMC/view?usp=sharing">Srebric</a>, J. and Chen, Q. 2001. “A Method of Test to Obtain Diffuser Data
			for CFD Modeling of Room Airflow,” <strong>ASHRAE Transactions</strong>, 107(2): 108-116.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1hX_JCNKzlFjOdRSV6nkZiP-H29ehzVr6/view?usp=sharing">Chen</a>, Q. and Srebric, J. 2000. “Application of CFD Tools for Indoor and
			Outdoor Environment Design,” Invited paper, <strong>Int. J. on Architectural Science</strong>, 1(1): 14-29.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1T9YtSX6mhPp1_FCRbMCZD0ukIoECS4qL/view?usp=sharing">Srebric</a>, J., Chen, Q., and Glicksman, L.R. 2000. “A Coupled Airflow-and-Energy
			Simulation Program for Indoor Thermal Environment Studies,”
			<strong> ASHRAE Transactions</strong>, 106(1): 465-476.
			</Typography>
			<br />
			<Typography variant="body1" align="left">
			<a href="https://drive.google.com/file/d/1v8CuwMIMNYSTKXydu2p0UYVkuntDzx7f/view?usp=sharing">Srebric</a>, J., Chen, Q., and Glicksman, L.R. 1999. “Validation of a
			Zero-equation Turbulence Model for Complex Indoor Airflows,”
			<strong> ASHRAE Transactions</strong>, 105(2): 414-427.
			</Typography>



		</Container>
	)
}
export default Publications;
